module.exports = __webpack_public_path__ + "img/Layer_1(2).2348b5b7.svg";